export class AddressInformation {
    addressFirstLine: string;
    addressSecondLine: string;
    addressThirdLine: string;
    addressFourthLine: String;
    city: string;
    state: string;
    country: string;
    zipCode: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3?: string;
    addressLine4?: string;
    name: string;
    stateId: number;
    countryCodeTwo: string;
    addressTypeId?: number;
    countryId?: number;
    countryCode?:string;
    postalCode?:string;
    stateCode?:string;
    phone?:string;
    id?:number |string;
}

export interface ShippingAddressInformation {
    id?: string;
    shippingAddressId?: string;
    addressVerified?: boolean;
    firstName?: string;
    lastName?: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3?: string;
    addressLine4?: string;
    countryId?: number;
    city: string;
    stateId?: number;
    stateCode: string;
    state?: string;
    countryCodeTwo?: string;
    countryCode: string;
    postalCode: string;
    phone: string;
    email?: string;

}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/address-detail-info.ts